import {
  fetchV1Invoices,
  fetchV1Invoice,
} from "@/services/v1/accountAPIService";

export default {
  state: {
    invoices: [],
    invoice: null,
    invoicePageSize: 5,
    totalInvoiceCount: 0,
  },
  getters: {
    invoices: (state) => state.invoices,
    invoice: (state) => state.invoice,
    currentInvoicePageSize: (state) => state.invoicePageSize,
    totalInvoiceCount: (state) => state.totalInvoiceCount,
  },
  mutations: {
    SET_INVOICES(state, invoices) {
      state.invoices = invoices;
    },
    SET_INVOICE(state, invoice) {
      state.invoice = invoice;
    },
    SET_INVOICE_PAGE_SIZE(state, pageSize) {
      state.invoicePageSize = pageSize;
    },
    SET_TOTAL_INVOICE_COUNT(state, count) {
      state.totalInvoiceCount = count;
    },
  },
  actions: {
    async fetchInvoices(
      { commit },
      {
        page = 1,
        pageSize = 5,
        payable = null,
        receivable = null,
        type = null,
      } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Invoices(
          page,
          pageSize,
          payable,
          receivable,
          type,
        );
        commit("SET_INVOICES", response.results);
        commit("SET_INVOICE_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_INVOICE_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching INVOICES:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async fetchInvoice({ commit }, invoiceNumber) {
      try {
        const response = await fetchV1Invoice(invoiceNumber);
        commit("SET_INVOICE", response);
      } catch (error) {
        console.error("Error fetching INVOICE:", error);
      }
      // finally {
      //   commit("SET_LOADING", false);
      //   console.log("finally...");
      // }
    },
  },
};
